
import 'components/catalog.tag'
import truncate from 'lodash/truncate'
import './products-types-edit-modal.tag'
riot.tag2('products-types-list', '  <catalog object="ProductType" cols="{cols}" search="true" reorder="true" handlers="{handlers}" allselect="true" reload="true" store="products-types-list" add="{permission(addEdit, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;products&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="features">{handlers.truncate(row.features, {length: 75})}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'ProductType';

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'features', value: 'Параметры' }];

self.addEdit = function (e) {
    var id = void 0;
    if (e && e.item && e.item.row) id = e.item.row.id;

    modals.create('products-types-edit-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;

            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'ProductType',
                    method: 'Save',
                    data: _this.item,
                    success: function success(response) {
                        popups.create({ title: 'Успех!', text: 'Тип продукта сохранен!', style: 'popup-success' });
                        observable.trigger('products-types-list-reload');
                        if (!id) _this.modalHide();
                    }
                });
            }
        }
    });
};

observable.on('products-types-list-reload', function () {
    return self.tags.catalog.reload();
});

self.handlers = { truncate: truncate };
});


// WEBPACK FOOTER //
// ./pages/products/products-types/products-types-list.tag